// Light / dark mode, remembered in this browser only.
import { useEffect, useState } from 'react'

const STORAGE_KEY = 'ffcamp-dark'

export function useDarkMode() {
  const [dark, setDark] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1'
    } catch {
      return false
    }
  })
  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark)
    try {
      localStorage.setItem(STORAGE_KEY, dark ? '1' : '0')
    } catch {
      // storage blocked: the choice lasts until the page reloads
    }
  }, [dark])
  return [dark, setDark] as const
}
